import { useEffect, useState } from 'react';

export default function ContactForm() {
    const [countries, setCountries] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        email: '',
        phone: '',
        country: ''
    });

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const res = await fetch('https://restcountries.com/v3.1/all?fields=cca2,name,flags');
                const data = await res.json();
                const sorted = data
                    .filter(c => c.cca2) // убедимся, что есть код
                    .sort((a, b) => a.name.common.localeCompare(b.name.common));
                setCountries(sorted);
            } catch (e) {
                console.error('Ошибка загрузки стран:', e);
            }
        };

        fetchCountries();
    }, []);

    const onFormSubmit = async (event) => {
        event.preventDefault();
        const payload = {
            name: `${formData.name} ${formData.surname}`,
            email:  formData.email,
            country:   formData.country,
            phone:   formData.phone,
            amount: 'more 5000',
            issue_category: 'alpha',
            message: '0.0.0.0',
            brand_id: '66a23df5f21c5349afe8021e'
        };

        try {
            const response = await fetch(
                'https://safekonma.com/lead/register-lead-from-brand',
                {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify(payload)
                }
            );
            if (!response.ok) {
                alert('Something went wrong. Please try again later.');
                return;
            }
            await response.json();
            console.log('Submitted data:', formData);
        } catch (e) {
            console.error('Error', e);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <form data-aos="fade-up" onSubmit={onFormSubmit}>
            <label>
                <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleChange}
                />
            </label>

            <label>
                <input
                    type="text"
                    name="surname"
                    placeholder="Surname"
                    value={formData.surname}
                    onChange={handleChange}
                />
            </label>

            <label>
                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                />
            </label>

            <label>
                <input
                    type="text"
                    name="phone"
                    placeholder="Phone"
                    value={formData.phone}
                    onChange={handleChange}
                />
            </label>

            <label>
                <select name="country" value={formData.country} onChange={handleChange}>
                    <option value="">Select country</option>
                    {countries.map((country) => (
                        <option key={country.cca2} value={country.cca2}>
                            {country.name?.common}
                        </option>
                    ))}
                </select>

            </label>

            <button type="submit" className="button">Submit</button>
        </form>
    );
}
